import { toast } from '../../lib/shadcn/sonner'

// Result of syncing customers to the Web site store locator
// (backend/customersPage/shared/storeLocator.ts).
export interface StoreLocatorSyncResult {
  synced: number
  removed: number
  failed: Array<{ customer_id: string; customer: string; error: string }>
  warnings: Array<{ customer_id: string; customer: string; warning: string }>
}

// Toast any store locator problems from a save. Returns true when nothing failed.
export function reportStoreLocatorSync(sync: StoreLocatorSyncResult | null | undefined): boolean {
  if (!sync) return true

  if (sync.failed.length > 0) {
    const first = sync.failed[0]!
    const more = sync.failed.length > 1 ? ` (+${sync.failed.length - 1} more)` : ''
    toast.error(`Store locator: ${first.customer}: ${first.error}${more}`)
    return false
  }

  if (sync.warnings.length > 0) {
    const first = sync.warnings[0]!
    const more = sync.warnings.length > 1 ? ` (+${sync.warnings.length - 1} more)` : ''
    toast.warning(`Store locator: ${first.customer}: ${first.warning}${more}`)
  }

  return true
}
